import Typography from "../../../designComponents/Typography";
import { getIconsUrl } from "../../../utils/resizeImages";
import ReviewButtons from "./review/ReviewButtons";
import { SectionTitle, StyledCard, ValueText } from "./styles";
import { PropertyFeaturesProps } from "./types";

const fieldKey = "Amenities";

const AmenitiesCard = ({
  propertyDetail,

  isAccepted,
  setOpenReviewModal,
  hasPreviousReview,
  hasRecentReview,
  onViewReviews,
}: PropertyFeaturesProps) => {
  return (
    <StyledCard style={{ margin: 0 }}>
      <SectionTitle>Amenities</SectionTitle>
      {isAccepted !== null && (
        <Typography
          style={{
            alignItems: "center",
            gap: "6px",
            color: isAccepted ? "green" : "red",
            fontWeight: 600,
            fontSize: "1rem",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          {isAccepted ? "Accepted" : "Rejected"}
        </Typography>
      )}
      <ValueText>
        {propertyDetail?.property?.amenities?.length === 0
          ? "No amenities"
          : null}
      </ValueText>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))",
          rowGap: 10,
          columnGap: 12,
        }}
      >
        {propertyDetail?.property?.amenities?.map((item: any, index) => {
          return (
            <div
              key={index}
              style={{
                display: "inline-flex",
                gap: 10,
                alignItems: "center",
              }}
            >
              <img
                src={getIconsUrl(item.icon)}
                alt="amenity"
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 50,
                }}
              ></img>
              <div>
                <Typography size={"h4"} style={{ color: "#3F3F3F" }}>
                  {item?.title}.{" "}
                </Typography>
              </div>
            </div>
          );
        })}
      </div>

      <ReviewButtons
        fieldKey={fieldKey}
        hasPreviousReview={hasPreviousReview}
        hasRecentReview={hasRecentReview}
        isAccepted={!!isAccepted}
        onViewReviews={onViewReviews}
        setOpenReviewModal={setOpenReviewModal}
        underReview={propertyDetail?.property.status === "UNDER_REVIEW"}
      />
    </StyledCard>
  );
};

export default AmenitiesCard;
